<template>
  <!-- <section> -->
  <!-- <div> -->
  <img
    class="rounded-full object-cover"
    :class="classStr"
    :src="src"
    alt=""
    @error="defaultCircleImage"
  />
  <!-- </div> -->
  <!-- </section> -->
</template>

<script>
export default {
  props: {
    classStr: String,
    src: String,
  },
};
</script>